import React from 'react';
import BasePage from '../../../core/page/BasePage';
import Pages from '../../../config/Pages';
import inputsAnaliseMetodologica from './PageInputs';
import BaseFilter from '../../../core/page/components/baseFilter/BaseFilter';
import { useOrgao } from '../Utils';
import { useInputs } from '../../../core/utils/Hooks';
import RotuloSeplag from '../../../components/rotuloSeplag/RotuloSeplag';
import AutoCompleteDropDown from '../../../core/components/inputs/AutoCompleteDropDown';
import { InputText } from 'primereact/inputtext';
import InputDropDown from '../../../core/components/inputs/inputDropDown/InputDropDown';
import BeforeActions from './components/BeforeActions';
import builder from '@rsql/builder';
import analiseMetodologicaService from '../../../service/AnaliseMetodologicaService';
import pessoaIntegracaoService from '../../../service/integracao/PessoaIntegracaoService';
import situacaoAvaliacaoService from '../../../service/SituacaoAvaliacaoService';

function AnaliseMetodologicaListagem() {
    const orgaoUsuarioLogado = useOrgao();
    const filterInputs = useInputs(inputsAnaliseMetodologica);

    const Rotulo = ({ children, ...rest }) => (
        <RotuloSeplag useInput={filterInputs} {...rest}>
            {children}
        </RotuloSeplag>
    );
    const Inputs = ({ formik }) => (
        <>
            <Rotulo cols="12">
                <AutoCompleteDropDown
                    name="orgao"
                    formik={formik}
                    selectedItemTemplate={(value) => value.descOrgao}
                    disabled={orgaoUsuarioLogado?.siglOrgao !== 'SEPLAG'}
                />
            </Rotulo>
            <Rotulo cols="12 3">
                <InputText
                    name="usuarioCadastro"
                    value={formik.values?.usuarioCadastro}
                    onChange={formik.handleChange}
                />
            </Rotulo>
            <Rotulo cols="12 3">
                <AutoCompleteDropDown
                    name="analistaMetodologica"
                    field="nomePessoa"
                    formik={formik}
                    service={pessoaIntegracaoService.autoComplete.bind(pessoaIntegracaoService)}
                />
            </Rotulo>
            <Rotulo cols="12 3">
                <InputText
                    name="numeroProposta"
                    value={formik.values?.numeroProposta}
                    onChange={formik.handleChange}
                />
            </Rotulo>
            <Rotulo cols="12 3">
                <InputText
                    name="nomeIndicador"
                    value={formik.values.nomeIndicador}
                    onChange={formik.handleChange}
                />
            </Rotulo>
            <Rotulo cols="12 3">
                <InputDropDown
                    name="situacaoAnalise"
                    formik={formik}
                    optionLabel="descSituacaoAvaliacao"
                    callbackSetList={situacaoAvaliacaoService.list.bind(situacaoAvaliacaoService)}
                />
            </Rotulo>
            <Rotulo cols="12 3">
                <InputDropDown
                    name="parecer"
                    formik={formik}
                    staticList={[
                        { codgTipoValidacaoMetodologica: 'VALIDADO', descricao: 'Validado' },
                        {
                            codgTipoValidacaoMetodologica: 'NAO_VALIDADO',
                            descricao: 'Não Validado',
                        },
                        {
                            codgTipoValidacaoMetodologica: 'NAO_VALIDADO_DESCARTADO',
                            descricao: 'Não validado / descartar alteração',
                        },
                    ]}
                />
            </Rotulo>
        </>
    );
    return (
        <BasePage
            service={analiseMetodologicaService}
            page={{
                pageUrls: Pages.sei.analiseMetodologica.url,
                legenda: Pages.sei.analiseMetodologica.legenda,
                pageName: Pages.sei.analiseMetodologica.title,
            }}
            initialValues={inputsAnaliseMetodologica.filter((input) => input?.table?.use ?? false)}
            enableAdicionar={false}
            enableAlterar={false}
            enableVisualizar={false}
            enableEditar={false}
            enableExcluir={false}
            addAfterActions={(dados) => <BeforeActions dados={dados} />}
        >
            <BaseFilter
                initialValues={inputsAnaliseMetodologica.filter(
                    (input) => input?.filter?.use ?? false
                )}
                prepareInitialValues={async (dados) => ({
                    ...dados,
                    orgao: orgaoUsuarioLogado,
                })}
                noEmptyInputsOnClear={orgaoUsuarioLogado?.siglOrgao === 'SEPLAG'}
                customFilter={{
                    orgao: ({ nameUse, original }) =>
                        builder.comparison(nameUse, '==', original?.idenOrgao),
                    analistaMetodologica: ({ nameUse, original }) =>
                        builder.comparison(nameUse, '==', original?.idenPessoa),
                }}
            >
                <Inputs />
            </BaseFilter>
        </BasePage>
    );
}

export default AnaliseMetodologicaListagem;
